<template>
  <el-row>
    <el-col :span="12" :offset="6">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="QRcode">
          <el-input type="text" style="display:none"></el-input>
          <el-input v-model="form.qrcode" type="text" placeholder="點擊此處后再掃描; 掃描前請清空" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="checkInBooking">立即簽到</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { checkInBooking, getCheckInBooking } from '../../utils/api'
export default {
  data () {
    return {
      form: {
        qrcode: ''
      },
      date: '',
      time: '',
      room: '',
      fbo: ''
    }
  },
  methods: {
    checkInBooking () {
      let that = this
      var fboId = this.form.qrcode.split('-')[0]
      var referenceId = this.form.qrcode.split('-')[1]
      let params = {
        reference_id: referenceId
      }
      getCheckInBooking(params).then(res => {
        console.log(res.data[0].booking_day)
        that.date = res.data[0].booking_day
        that.time = res.data[0].booking_time
        that.room = res.data[0].booking_room.id
        that.fbo = res.data[0].booking_user.name
      })
      const h = this.$createElement
      this.$msgbox({
        title: that.fbo,
        message: h('p', null, [
          h('span', null, ' ' + that.date + '  '),
          h('span', null, ' ' + that.time + '  '),
          h('i', { style: 'color: teal' }, '  ' + that.room)
        ]),
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '請稍等...'
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 150)
            }, 1000)
          } else {
            done()
          }
        }
      }).then(action => {
        let params = {
          status: 'show',
          fbo_id: fboId,
          reference_id: referenceId
        }
        checkInBooking(referenceId, params).then(res => {
          console.log(res)
          this.$message({
            type: 'success',
            message: '簽到成功'
          })
        }).catch(err => {
          console.log(err)
          this.$message({
            type: 'error',
            message: '簽到失敗'
          })
        })
      })
    }
  }
}
</script>

<style>
.el-form-item__label {
  font-size: 20px;
  font-weight: 600;
  color: #ffc600
}
</style>



// WEBPACK FOOTER //
// src/components/views/CheckIn.vue